export const STYLE_TRANSITION_ALL = 'all 0.45s ease'

export const menuLabelFontSize = {
	base: '11px',
	md: '12px',
	xxl: '13px',
	jumbo: '14px',
}
